import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import AnalyticsSectionalForTeacher from '../components/MT_Score/AnalyticsSectionalForTeacher'
import ScoreViewHeaderForTeacher from '../components/MT_Score/ScoreViewHeaderForTeacher'

const MtScoreAnalyticsSectionalForTeacher = () => {
  return (
    <>
     <ScoreViewHeaderForTeacher />
    <AnalyticsSectionalForTeacher />
    </>
  )
}

export default MtScoreAnalyticsSectionalForTeacher